import { VStack } from '@chakra-ui/react';
import { useMemo } from 'react';
import { HistorySidebar } from 'Features/History/HistorySidebar';
import { useEsrsAuditLogs } from 'Features/History/History.hooks';
import { useEsrsAssessmentQuery } from 'models';
import { useParams } from 'react-router-dom';
import { Typography } from 'Tokens';

export const MetricUpdates = ({ answerId }: { answerId?: string }) => {
  const { esrsAssessmentId } = useParams();

  const { data } = useEsrsAssessmentQuery({
    variables: { esrsAssessmentId },
    skip: !esrsAssessmentId,
  });

  const esrsAssessment = useMemo(() => data?.esrsAssessment, [data]);

  const { auditLogs } = useEsrsAuditLogs({ esrsAssessment, answerId, isSidebar: true });
  return (
    <VStack alignItems="start" width="100%" p="24px 20px" spacing="12px">
      {!auditLogs.length && (
        <Typography variant="body" color="text.hint" alignSelf="center">
          There are no updates yet
        </Typography>
      )}
      <HistorySidebar auditLogs={auditLogs} loading={false} searchValue={''} noPadding />
    </VStack>
  );
};
